const initialState = {     
      statusType: 'ALL',
	filterText: ''
}

const emailAddressListFiltersReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_EMAIL_ADDRESS_LIST_FILTERS':
                  return {
                        ...state,
                        statusType: action.filters.statusType,
                        filterText: action.filters.filterText
                  }
            case 'UPDATE_CURRENT_USER':
            case 'LOGOUT_USER':
                  return {
                        statusType: 'ALL',
                        filterText: ''
                  }
            default:
                  return state;
      }

};
export default emailAddressListFiltersReducer;